import { useState } from 'react';
import { IFieldErrors } from 'src/types/validation';
import { Draft } from 'src/types/common';

export interface IFormProps<T> {
  item?: Partial<T>;
  onComplete: (data: T) => void;
  onCancel: () => void;
}

export interface IFieldProps<T> {
  readOnly?: boolean;
  item: Draft<T>;
  validating?: boolean;
  errors: IFieldErrors;
  original?: Draft<T>;
  showDiff?: boolean;
  onUpdate?: (address: Draft<T>) => void;
}

export function useSubform<T>() {
  const [isOpen, setOpen] = useState<boolean>(false);
  const [data, setData] = useState<T | undefined>(undefined);

  const open = (data?: T) => {
    setData(data);
    setOpen(true);
  };

  const close = () => {
    setData(undefined);
    setOpen(false);
  };

  return { isOpen, data, open, close };
}